type QueryParameterValue = string | number | readonly number[] | undefined;

const toQueryString = (parameters: Record<string, QueryParameterValue>): string => {
  const searchParameters = new URLSearchParams();

  for (const [key, value] of Object.entries(parameters)) {
    if (value === undefined) {
      continue;
    }

    if (Array.isArray(value)) {
      for (const item of value) {
        searchParameters.append(key, String(item));
      }

      continue;
    }

    searchParameters.set(key, String(value));
  }

  return searchParameters.toString();
};

export default toQueryString;
